import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { get, isEmpty } from 'lodash'
import classNames from 'classnames'

import { parseTimezone } from '../../utils/parseTimezone'
import Section from '../Section'

const EventList = ({
  currentEventId,
  currentVenueTimezone,
  data,
  history,
  setEventsScrollPosition,
}) => {
  const [ selectedEventId, setSelectedEventId ] = useState(currentEventId)

  const handleEscapeKey = useCallback(({ keyCode }) => {
    const escapeKey = 27

    keyCode === escapeKey && setSelectedEventId(currentEventId)
  }, [currentEventId])

  useEffect(() => {
    document.addEventListener('keydown', handleEscapeKey)

    return () => document.removeEventListener('keydown', handleEscapeKey)
  }, [currentEventId, handleEscapeKey])


  const renderEvent = (event) => {
    const eventStartTime = parseTimezone(event?.startTime, currentVenueTimezone)
    const selected = selectedEventId
    const className = classNames('event', { selected: selected === event.uuid })

    return (
      <div
        key={event.uuid}
        className={className}
        onClick={() => {
          setSelectedEventId(event.uuid)
          setEventsScrollPosition()
          history.push(`/events/${event.uuid}`)
        }}
      >
        <div className="row">
          <div className="name-date-wrapper">
            <span className="name">{get(event, 'name', '')}</span>
            <span className="date">{' - '}{eventStartTime}</span>
          </div>
          <span className="event-type-name">{get(event, 'eventType.name', '')}</span>
        </div>
      </div>
    )
  }

  if (isEmpty(data)) return null

  return (
    <Section className='event-list'>
      {data.map(renderEvent)}
    </Section>
  )
}

EventList.defaultProps = {
  currentEventId: '',
  currentVenueTimezone: '',
  data: [],
  setEventsScrollPosition: () => {},
}

EventList.propTypes = {
  currentEventId: PropTypes.string,
  currentVenueTimezone: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  setEventsScrollPosition: PropTypes.func,
}

export default EventList
